import Vue from 'vue'
import { getAnalytics, logEvent, setCurrentScreen } from 'firebase/analytics'

let analytics

const setAnalyticsApp = firebaseApp => {
  analytics = getAnalytics(firebaseApp)
}

const analyticsEvent = (eventName, eventData = {}) => {
  logEvent(analytics, eventName, eventData)
}

const screenEvent = (screenName) => {
  setCurrentScreen(analytics, screenName)
}

const Day6Actions = {
  openInfo: 'open-info',
  mailingList: 'mailing-list',
  resetDimensions: 'reset-dimensions',
  openPose: 'open-pose',
  openBuildBody: 'open-build-body',
  openPreview: 'open-preview',
  openAccount: 'open-account',
  openAccountPay: 'open-account-pay',
  saveChanges: 'save-changes',
  estimatePose: 'estimate-pose',
  // TODO Estimate pose apply
  // TODO Estimate pose cancel
  downloadAsset: 'download-asset',
  shareLink: 'share-link',
  toggleColor: 'toggle-color',
  zoomExtents: 'zoom-extents'
  // TODO Generate start
  // TODO Generate cancel
  // TODO Generate set
  // TODO Generate end mirroring
  // TODO Character browser actions
  // TODO Pose sequence view actions
}
const Day6ActionEventNames = new Set(Object.values(Day6Actions))

const QuickytoolsActions = {
  openPurchaseSubscription: 'open-purchase-subscription',
  openActivateFreeTrial: 'open-activate-free-trial'
}
const QuickytoolsActionEventNames = new Set(Object.values(QuickytoolsActions))
const QuickytoolsAnalyticsEvents = {
  freeTrialRedeemed: 'free-trial-redeemed',
  freeTrialFailRedemption: 'free-trial-fail-redemption',
  freePassRedeemed: 'free-pass-redeemed'
}

const onActionPress = (actionNames, key) => {
  const isRecognizedAction = actionNames.has(key)
  const eventName = isRecognizedAction ? `action-press-${key}` : 'action-press'
  const data = isRecognizedAction ? {} : { label: key }
  analyticsEvent(eventName, data)
}

const approvedEvents = new Set(Object.values(QuickytoolsAnalyticsEvents))
const onCaptureEvent = (key, data) => {
  if (!approvedEvents.has(key)) {
    Vue.logger.error(new Error(`Unapproved analytics event ${key}`))
    return
  }

  analyticsEvent(key, data || {})
}

const day6Analytics = {
  buildRequestStart: () => {
    analyticsEvent('day6-build-body')
  },
  shareOpen: (shareCount) => {
    analyticsEvent('share-open', { label: `${shareCount}` })
  },
  onOpenAccount: (isAuthenticated, isOpeningPay) => {
    const eventName = isOpeningPay
      ? Day6Actions.openAccountPay
      : Day6Actions.openAccount
    const label = isAuthenticated ? 'auth' : 'public'
    analyticsEvent(eventName, { label })
  },
  onSaveChanges: source => {
    analyticsEvent(Day6Actions.saveChanges, { label: source })
  },
  actionPress: (key) => onActionPress(Day6ActionEventNames, key)
}

const quickytoolsAnalytics = {
  submitMailingList: (listKey) => {
    analyticsEvent('mailing-list-submit', { label: listKey })
  },
  actionPress: (key) => onActionPress(QuickytoolsActionEventNames, key),
  captureEvent: (key, data) => onCaptureEvent(key, data)
}

export {
  setAnalyticsApp,
  analyticsEvent,
  screenEvent,
  quickytoolsAnalytics,
  day6Analytics,
  QuickytoolsActions,
  QuickytoolsAnalyticsEvents,
  Day6Actions
}
